(function() {
    'use strict';

    angular
        .module('sgnmrApp')
        .factory('PalabraClaveSearch', PalabraClaveSearch);

    PalabraClaveSearch.$inject = ['$resource'];

    function PalabraClaveSearch($resource) {
        var resourceUrl =  'api/_search/palabra-claves/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
